import store from "@/store";
import DepService from "@/api/services/depService";
import setUserSessionData from "@/functions/setUserSessionData";
import {setAuthToken} from "@/functions/authTokenStorage";

const ENTITLED_STATUS_NAMES = new Set(['ACTIVE', 'GRACE', 'SUSPENDED']);

const SIGNED_PARAM_NAMES = [
    'sigts', 'sigv1',
    'depserviceid', 'bpSvc', 'msisdn', 'result', 'result_id',
    'subscription_id', 'channel', 'ext_ref',
];

export function isMyBundleEntry(rawQueryString = window.location.search) {
    return /[?&]sigv1=/.test(rawQueryString);
}

export async function handleMyBundleEntry() {
    const productId = store.state.productId;
    let data;

    try {
        data = await DepService.validateMyBundleEntry(productId, window.location.search);
    } catch (error) {
        console.log('My Bundle entry request failed', error);
        stripSignedParams();
        return {entered: false, reason: 'REQUEST_FAILED'};
    }

    stripSignedParams();

    if (!data?.token) {
        console.log(`My Bundle entry rejected: ${data?.reason ?? 'NO_TOKEN'}`);
        return {entered: false, reason: data?.reason ?? 'NO_TOKEN'};
    }

    setAuthToken(data.token);

    const user = (await DepService.getUserViaProductId(data.msisdn, productId))?.data?.user;
    if (!user || !ENTITLED_STATUS_NAMES.has(user.statusName)) {
        console.log(`My Bundle entry not entitled: statusName=${user?.statusName}`);
        return {entered: false, reason: 'NO_ENTITLEMENT', statusName: user?.statusName};
    }

    store.commit('setMsisdn', user.msisdn);
    store.commit('setUser', user);
    store.commit('setMyBundle', true);
    if (user.serviceId) store.commit('setServiceId', user.serviceId);
    setUserSessionData(user.msisdn, user.serviceId);
    localStorage.setItem('msisdn', user.msisdn);

    return {entered: true, user};
}

function stripSignedParams() {
    const params = new URLSearchParams(window.location.search);
    SIGNED_PARAM_NAMES.forEach((name) => params.delete(name));
    const query = params.toString();
    window.history.replaceState({}, document.title, `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
}
